module.exports = __webpack_public_path__ + "static/media/Report.36e718d9.png";